import { render, staticRenderFns } from "./AppUserProfileComponent.vue?vue&type=template&id=1c877da1&scoped=true"
import script from "./AppUserProfileComponent.vue?vue&type=script&lang=js"
export * from "./AppUserProfileComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c877da1",
  null
  
)

export default component.exports